export const styledTableContainer = () => ({
  display: 'flex',
  flexFlow: 'column',
  gap: '16px',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
  position: 'relative'
});